import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormilyFormProps } from '.';

export const generate = (
  props: Partial<IComponentSchema<IFormilyFormProps>>
): IComponentSchema<IFormilyFormProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.OBJECT,
    name: props?.name || id,
    'x-component': ComponentType.Form,
    'x-component-props': props?.['x-component-props'] || {},
    'x-component-props-config': {},
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    properties: {},
  };
};
